import { useMemo } from "react";
import { LinkAndroidIcon, LinkIconInput, LinkIosIcon } from "../../AscIcons";
import classNames from "classnames";
import styles from "./AscLinkInput.module.scss";

type AscLinkInputSize = "small" | "medium" | "large";
type AscLinkInputVariant = "default" | "ios" | "android";

export interface AscLinkInputProps
  extends Omit<
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    "size"
  > {
  size?: AscLinkInputSize;
  innerInputClassName?: string;
  inputWrapperClassName?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: AscLinkInputVariant;
}

export default function AscLinkInput({
  size = "medium",
  className,
  innerInputClassName,
  inputWrapperClassName,
  fullWidth = false,
  variant = "default",
  ...rest
}: AscLinkInputProps) {
  const linkIcon = useMemo(() => {
    switch (variant) {
      case "ios":
        return <LinkIosIcon className={styles.icon} />;
      case "android":
        return <LinkAndroidIcon className={styles.icon} />;
      default:
        return <LinkIconInput className={styles.icon} />;
    }
  }, [variant]);

  return (
    <div
      className={classNames(
        styles.ground,
        {
          [styles.large]: size === "large",
          [styles.medium]: size === "medium",
          [styles.small]: size === "small",
          [styles.disabled]: rest?.disabled,
          [styles.fullWidth]: fullWidth,
        },
        className
      )}
    >
      <div className={styles.iconGround}>{linkIcon}</div>
      <div className={classNames(styles.inputWrapper, inputWrapperClassName)}>
        <input
          className={classNames(styles.innerInput, innerInputClassName)}
          placeholder="Link"
          {...rest}
        />
      </div>
    </div>
  );
}
